import { callApiToServer } from "../callApi";

export async function editCourseSessionTopic(
  authToken,
  courseObject,
  courseId
) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authToken,
    };

    console.log("[ADMIN API EDIT TOPIC PAYLOAD]:", courseObject);
    let body = JSON.stringify(courseObject);

    let endUrl = "v1/auth/admin/edit-course-session-topic";
    console.log("endUrl printed here", endUrl);

    let responseData = await callApiToServer(body, header, "PUT", endUrl);
    console.log("[ADMIN API EDIT TOPIC SERVER RESPONSE]:", responseData);

    return responseData;
  } catch (err) {
    throw err;
  }
}
